$(document).ready(function() {

    
    const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
    const strapDrawerEnabled =
    (urlParams.get('strap_drawer') === 'true' || urlParams.get('strap_finder') === 'true') &&
    !document.body.classList.contains('template-page-strap-finder-results') &&
    !urlParams.has('watch_brand');
    

    function getCombinedHeight() {
        var headerHeight = $('.shopify-section--header').outerHeight() || 0;
        var announcementBarHeight = $('height-observer[variable="announcement-bar"]').outerHeight() || 0;
        var strapFinderHeight = $('.strap-finder-details-sec').outerHeight() || 0;
    
        return headerHeight + announcementBarHeight + strapFinderHeight;
    }

    var totalHeight = getCombinedHeight();

    $(window).on('resize', function () {
        totalHeight = getCombinedHeight();
    });

    $(window).on('scroll', function () {
        var scrollVal = $(this).scrollTop();
        console.log("scrollval: ", scrollVal);

        if (scrollVal >= 700) {
            $('body').addClass('scrollable-pause');
        } else {
            $('body').removeClass('scrollable-pause');
        }
    });

    const $drawer = $('.strap-drawer');
    const $toggle = $('#strap-finder-toggle');
    const $closeBtn = $('.strap-drawer-close');
    const $changewatch = $('.change-watch-text');

    
    setTimeout(function() {
        if (strapDrawerEnabled) {
            if (!($('body').hasClass('loading-select') && $('.loading-strap-spinner').hasClass('visible'))) {
                $drawer.addClass('open-strap');
                $('body').addClass('strap-finder-open');
            }
        }
    }, 1500);
    

    // Open strap drawer
    $toggle.on('click', function(e) {
        if ($('body').hasClass('loading-select') && $('.loading-strap-spinner').hasClass('visible')) {
            return;
        }
        e.stopPropagation();
        $drawer.addClass('open-strap');
        $('body').addClass('strap-finder-open');
    });

    $changewatch.on('click', function(e) {
        if ($('body').hasClass('loading-select') && $('.loading-strap-spinner').hasClass('visible')) {
            return;
        }
        e.stopPropagation();
        $drawer.addClass('open-strap');
        $('body').addClass('strap-finder-open change-watch-drawer-open');

        // Only restore selections from URL if strap_drawer=true
        if (strapDrawerEnabled) {
            restoreSelectionsFromURL();
        }
    });

    $closeBtn.on('click', function() {
        if ($('body').hasClass('loading-select') && $('.loading-strap-spinner').hasClass('visible')) {
            return;
        }
        $drawer.removeClass('open-strap');
        $('body').removeClass('strap-finder-open change-watch-drawer-open');
    });

    $(document).on('pointerdown', function(e) {
        if ($('body').hasClass('loading-select') && $('.loading-strap-spinner').hasClass('visible')) {
            return;
        }
        if ($drawer.hasClass('open-strap') && !$(e.target).closest('.strap-drawer-inn, #strap-finder-toggle, .strap-finder-select').length) {
            $drawer.removeClass('open-strap');
            $('body').removeClass('strap-finder-open change-watch-drawer-open');
        }
    });

    $(document).on('keydown', function(e) {
        if ($('body').hasClass('loading-select') && $('.loading-strap-spinner').hasClass('visible')) {
            return;
        }
        if (e.key === "Escape" && $drawer.hasClass('open-strap')) {
            $drawer.removeClass('open-strap');
            $('body').removeClass('strap-finder-open change-watch-drawer-open');
        }
    });

    $drawer.on('click', function(e) {
        if ($('body').hasClass('loading-select') && $('.loading-strap-spinner').hasClass('visible')) {
            e.stopImmediatePropagation();
            e.preventDefault();
            return false;
        }
    });

    function restoreSelectionsFromURL() {
        var params = window.getQueryParams ? window.getQueryParams() : {};
        var brand = params.watch_brand;
        var name = params.watch_name;

        if (!brand || !name || !window.StrapFinder) return;

        var $brandSelect = $('#brand-select');
        var $collectionSelect = $('#collection-select');

        $brandSelect.val(brand);
        window.StrapFinder.populateCollections(brand);

        setTimeout(function() {
            var matchedModel = null;
            window.StrapFinder.strapInfos.forEach(function(item) {
                if (item.watch_brand === brand && item.watch_name === name) {
                    matchedModel = item.watch_model;
                }
            });

            if (matchedModel) {
                $collectionSelect.val(matchedModel);
                window.StrapFinder.populateWatches(brand, matchedModel);
                sessionStorage.setItem('selectedBrand', brand);
                sessionStorage.setItem('selectedModel', matchedModel);
            } else {
                window.StrapFinder.populateWatches(brand, null);
                sessionStorage.setItem('selectedBrand', brand);
                sessionStorage.removeItem('selectedModel');
            }

            window.StrapFinder.showResetButton();
        }, 500);
    }

});